import { SF } from '@/storefront';


window.addEventListener('resize', resizeContainer);

SF.onReady((): void => {
    resizeContainer();
});

function resizeContainer(): void {
    const container = document.querySelector('.main-content') as HTMLElement | null;
    const galleryContainer = document.getElementById('galleryContainer') as HTMLElement | null;
    const galleryContent = document.querySelector('.jsonGallery') as HTMLElement | null;
    const editorGalleryControls = document.querySelector('.editorGalleryControls') as HTMLElement | null;

    if (!container) return;

    // jQuery outerHeight() equivalent
    const outerHeight = container.offsetHeight;

    // jQuery height() equivalent (content height)
    const contentHeight = container.clientHeight;

    const paddingTop = (outerHeight - contentHeight) / 2;

    const rect = container.getBoundingClientRect();
    const offsetTop = rect.top + window.scrollY;

    const height = window.innerHeight - offsetTop - paddingTop;

    if (container.clientHeight !== height) {
        container.style.height = `${height}px`;

        if (galleryContainer && galleryContent) {
            const galleryContainerHeight = galleryContainer.clientHeight;

            const controlsOuterHeight = editorGalleryControls
                ? editorGalleryControls.offsetHeight
                : 0;

            galleryContent.style.height =
                `${galleryContainerHeight - controlsOuterHeight}px`;
        }
    }
}